var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const API_HOST = '/gateway';
const getQuoteForRoute = (sourceAmount, sourceCurrency, targetCurrency) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield fetch(`${API_HOST}/v3/quotes`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            sourceAmount,
            sourceCurrency,
            targetCurrency,
            guaranteedTargetAmount: false,
            type: 'REGULAR',
        }),
    });
    const data = (yield response.json());
    return data.paymentOptions.find((paymentOption) => paymentOption.payIn === 'BANK_TRANSFER' && paymentOption.payOut === 'BANK_TRANSFER');
});
const getHistoricalRate = (sourceCurrency, targetCurrency, dateTime) => __awaiter(void 0, void 0, void 0, function* () {
    const RATE_TOKEN = 'OGNhN2FlMjUtOTNjNS00MmFlLThhYjQtMzlkZTFlOTQzZDEwOjliN2UzNmZkLWRjYjgtNDEwZS1hYzc3LTQ5NGRmYmEyZGJjZA';
    const params = new URLSearchParams({
        source: sourceCurrency,
        target: targetCurrency,
        time: dateTime,
    });
    const response = yield fetch(`${API_HOST}/v1/rates?${params.toString()}`, {
        headers: {
            Authorization: `Basic ${RATE_TOKEN}`,
        },
    });
    const data = (yield response.json());
    return data[0].rate;
});
export const compareProvider = (formData) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d;
    const [quote, historicalRate] = yield Promise.all([
        getQuoteForRoute(formData.sentAmount, (_a = formData.sourceCurrency) === null || _a === void 0 ? void 0 : _a.code.toUpperCase(), (_b = formData.targetCurrency) === null || _b === void 0 ? void 0 : _b.code.toUpperCase()),
        getHistoricalRate((_c = formData.sourceCurrency) === null || _c === void 0 ? void 0 : _c.code.toUpperCase(), (_d = formData.targetCurrency) === null || _d === void 0 ? void 0 : _d.code.toUpperCase(), new Date(formData.date).toISOString().replace('Z', '')),
    ]);
    const receivedAmount = (formData.sentAmount - quote.fee.transferwise) * historicalRate;
    return {
        sourceCurrencyCode: formData.sourceCurrency.code.toUpperCase(),
        targetCurrencyCode: formData.targetCurrency.code.toUpperCase(),
        sentAmount: formData.sentAmount,
        wise: {
            receivedAmount,
            exchangeRate: historicalRate,
            transferFees: quote.fee.transferwise,
            exchangeRateMarkup: 0,
        },
        competitor: {
            receivedAmount: formData.receivedAmount,
            exchangeRate: formData.exchangeRate,
        },
    };
});
